import { setupTheme } from './actions';
import themeReducer from './reducer';

export { setupTheme, themeReducer };
